/**
 * Canonical PredictionHero social profile URLs — the single source of truth
 * for both the footer (`constants/socials.ts`) and the Organization JSON-LD
 * `sameAs` entity signal (`jsonLD/site.ts`).
 *
 * Kept in a dependency-free module (no MUI/Intercom imports) so it is safe to
 * pull into the SSR `meta`/structured-data path. Values must stay exact and
 * clean — no leading/trailing whitespace — since they double as machine-
 * readable identity links for search engines and LLMs.
 */
export const SOCIAL_PROFILE_URLS = {
  x: "https://x.com/Prediction_Hero",
  linkedin: "https://www.linkedin.com/company/predictionhero",
  instagram: "https://www.instagram.com/predictionheroHQ",
  tiktok: "https://www.tiktok.com/@predictionHero",
  facebook: "https://www.facebook.com/predictionhero",
} as const;

/** All profile URLs as a plain array (order = footer display order). */
export const SOCIAL_PROFILE_URL_LIST: readonly string[] =
  Object.values(SOCIAL_PROFILE_URLS);
